import { Injectable } from '@angular/core';

@Injectable()
export class HelpersService {
  constructor() {}

  static loadGoogleAnalytics(trackingID: string): void {
    let gaScript = document.createElement('script');
    gaScript.setAttribute('async', 'true');
    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

    let gaScript2 = document.createElement('script');
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

    document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }

  static loadFacebookAnalytics(trackingID: string): void {
    // let gaScript = document.createElement('script');
    // gaScript.setAttribute('async', 'true');
    // gaScript.setAttribute('src',
    //  `https://www.googletagmanager.com/gtag/js?id=${trackingID}`
    //  );

    let gaScript2 = document.createElement('script');
    gaScript2.innerHTML = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', ${trackingID});
    fbq('track', 'PageView');`;

    // document.documentElement.firstChild.appendChild(gaScript);
    document.documentElement.firstChild.appendChild(gaScript2);
  }
  static loadBavarianReservationComplete(): void {
    // Prevent duplicate iframe loads
    if (document.getElementById('bavarian-reservation-complete-iframe')) return;

    const iframe = document.createElement('iframe');
    iframe.id = 'bavarian-reservation-complete-iframe';
    iframe.src = 'https://bavarian-village.com/reservation-complete/';
    iframe.title = '';
    iframe.setAttribute('loading', 'eager'); // fixed
    iframe.style.border = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.visibility = 'hidden';
    iframe.tabIndex = -1;

    // Listen for load and error events
    iframe.onload = () => console.log('Iframe loaded successfully!');
    iframe.onerror = () => console.log('Iframe failed to load');

    const wrapper = document.createElement('div');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.style.position = 'absolute';
    wrapper.style.width = '0';
    wrapper.style.height = '0';
    wrapper.style.overflow = 'hidden';
    wrapper.appendChild(iframe);

    document.body.appendChild(wrapper);
    console.log('Iframe appended and loading started');
  }

  // static loadGoogleTagManager(containerId: string): void {
  //   if (!containerId) {
  //     console.error('GTM container ID is required.');
  //     return;
  //   }

  //   if (document.getElementById('gtm-script')) {
  //     console.log('Google Tag Manager already loaded.');
  //     return;
  //   }

  //   const script = document.createElement('script');
  //   script.id = 'gtm-script';
  //   script.async = true;
  //   script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  //   document.head.appendChild(script);

  //   const initScript = document.createElement('script');
  //   initScript.innerHTML = `
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     'gtm.start': new Date().getTime(),
  //     event: 'gtm.js'
  //   });
  // `;
  //   document.head.appendChild(initScript);

  //   console.log('Google Tag Manager initialized:', containerId);
  // }

  // static pushGTMEvent(eventName: string, data?: any): void {
  //   (window as any).dataLayer = (window as any).dataLayer || [];
  //   if (!(window as any).dataLayer) {
  //     console.warn(`GTM not initialized. Event "${eventName}" not sent.`);
  //     return;
  //   }

  //   (window as any).dataLayer.push({ event: eventName, ...data });
  //   console.log('GTM Event pushed:', eventName, data || {});
  // }

  private static isInitialized = false;
  private static eventQueue: any[] = [];

  /**
   * Load Google Tag Manager
   */
  static loadGoogleTagManager(containerId: string): void {
    if (!containerId) {
      console.warn('No GTM container ID provided. Skipping initialization.');
      return;
    }

    if (document.getElementById('gtm-script')) {
      console.log('GTM already loaded.');
      return;
    }

    // Create GTM script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
    script.onload = () => {
      this.isInitialized = true;

      // Push queued events after GTM loads
      this.eventQueue.forEach(e => (window as any).dataLayer.push(e));
      this.eventQueue = [];
      HelpersService.pushGTMEvent('reservation_step', { step: 'Step 1: Reservation started' });
    };
    document.head.appendChild(script);

    // Initialize dataLayer
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    console.log('Google Tag Manager initialized:', containerId);
  }

  /**
   * Push custom GTM event
   */
  static pushGTMEvent(eventName: string, data?: any): void {
    const eventObj = { event: eventName, ...data };

    if (!this.isInitialized) {
      // Queue events until GTM is loaded
      this.eventQueue.push(eventObj);
      console.log('Event queued until GTM loads:', eventObj);
      return;
    }

    (window as any).dataLayer.push(eventObj);
    console.log('GTM Event pushed:', eventObj);
  }
}
